const tiendas = window.info__liquid__tiendas;
const buscador__tiendas = document.querySelector("#buscador__tiendas input");
const listado__tiendas = document.querySelector("#listado__tiendas");
const cargar__tiendas = document.querySelector("#cargar__tiendas button");


const filtrador = () => {
    const buscador__value = buscador__tiendas.value.toLowerCase();
    const buscador__length = buscador__tiendas.value.length;

    if (buscador__length >= 3 && (buscador__value != "tie" && buscador__value != "tien" && buscador__value != "tiend" && buscador__value != "tienda")) {
        listado__tiendas.innerHTML = '';
        cargar__tiendas.style.display = "none";

        for (const tienda of tiendas) {
            let nombre = tienda.TIENDA.toLowerCase();
            let cp = String(tienda['C.P']);

            if (nombre.indexOf(buscador__value) !== -1 || cp.indexOf(buscador__value) !== -1) {
                listado__tiendas.innerHTML += format__tiendas(tienda['TIENDA'], tienda['Fotos Tienda'], tienda['C.P'], tienda['Dirección postal'], tienda['Teléfono fijo'], tienda['Horario'], tienda['URL Google']);
            }

        }

        if (listado__tiendas.innerHTML == '') {
            listado__tiendas.innerHTML = '<p>Tienda no encontrada</p>';
        }

    }

    if (buscador__value == '') {
        listado__tiendas.innerHTML = '';
        init__tiendas();
        cargar__tiendas.style.display = "initial";
    }

}

const init__tiendas = () => {
    for (const tienda of tiendas.slice(0, 10)) {
        listado__tiendas.innerHTML += format__tiendas(tienda['TIENDA'], tienda['Fotos Tienda'], tienda['C.P'], tienda['Dirección postal'], tienda['Teléfono fijo'], tienda['Horario'], tienda['URL Google']);
    }
}

const load__tiendas = () => {

    let contador__tiendas = document.querySelectorAll(".tienda").length;
    for (const tienda of tiendas.slice(contador__tiendas, contador__tiendas + 10)) {
        listado__tiendas.innerHTML += format__tiendas(tienda['TIENDA'], tienda['Fotos Tienda'], tienda['C.P'], tienda['Dirección postal'], tienda['Teléfono fijo'], tienda['Horario'], tienda['URL Google']);
    }


}

const format__tiendas = (nombre, imagen, codigo_postal, direccion, telefono, horario, maps) => {
    return `
    <div class="tienda">
      <div class="tienda__container">
        <h3 class="tienda__title">${nombre}</h3>
        <div class="tienda__body">
            <img src="https://d7rh5s3nxmpy4.cloudfront.net/CMP6808/1/${imagen}" alt="${nombre}" width="270" height="200" class="tienda__img">
            <div class="tienda__info">
                <div class="tienda__direccion">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>map-search-outline</title>
                  <path d="M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.2 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,
                  14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M19.5,2A0.5,0.5 0 0,1 20,2.5V11.81C19.42,
                  11.26 18.75,10.81 18,10.5V4.7L15,5.86V10C14.3,10.07 13.62,10.24 13,10.5V5.87L9,4.47V16.13H9V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20A0.5,
                  0.5 0 0,1 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2.03L19.5,2M4,5.46V17.31L7,16.15V4.45L4,5.46Z" /></svg>
                  <p>${codigo_postal} - ${direccion}</p>
                </div>

                <div class="tienda__telefono">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>phone-outline</title>
                  <path d="M20,15.5C18.8,15.5 17.5,15.3 16.4,14.9C16.3,14.9 16.2,14.9 16.1,14.9C15.8,14.9 15.6,15 15.4,15.2L13.2,17.4C10.4,15.9 8,13.6 6.6,10.8L8.8,8.6C9.1,
                  8.3 9.2,7.9 9,7.6C8.7,6.5 8.5,5.2 8.5,4C8.5,3.5 8,3 7.5,3H4C3.5,3 3,3.5 3,4C3,13.4 10.6,21 20,21C20.5,21 21,20.5 21,20V16.5C21,16 20.5,15.5 20,
                  15.5M5,5H6.5C6.6,5.9 6.8,6.8 7,7.6L5.8,8.8C5.4,7.6 5.1,6.3 5,5M19,19C17.7,18.9 16.4,18.6 15.2,18.2L16.4,17C17.2,17.2 18.1,17.4 19,17.4V19Z" /></svg>
                  <p>${telefono}</p>
                </div>

                <div class="tienda__horario">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>clock-time-four-outline</title>
                  <path d="M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 
                  12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z" /></svg>
                  <p>${horario}</p>
                </div>

                <a href="${maps}" target="_blank">Ver en google maps</a>
            </div>
        </div>
    </div></div>
    `;
}

init__tiendas();
cargar__tiendas.addEventListener('click', load__tiendas);
buscador__tiendas.addEventListener('keyup', filtrador);